import React from 'react';
import '../App.css';
import { formatDateTime, formatToShortDate } from '../utils/dateutils';

const SuperAdminTable = ({ filterby, tableData, tableloading }) => {
    return (
        <div className="w-full max-w-full overflow-x-auto  custom-scrollbar ">
            <div className="max-h-[400px] overflow-y-auto custom-scrollbar ">
                <table className="w-full min-w-[1000px] border-collapse rounded-full">
                    <thead className="sticky top-0 bg-[#F9FAFB] z-10">
                        <tr className="border border-gray-300 text-[#900]">
                            <th className="p-3 pl-9 w-[10%] text-start">Supervisor</th>
                            <th className="p-3 w-[10%] text-start">Date</th>
                            <th className="p-3 w-[15%] text-start">Company</th>
                            <th className="p-3 w-[10%] text-start">Number of Entries</th>
                            <th className="p-3 w-[20%] text-start">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableloading ? (
                            <tr>
                                <td colSpan="5" className="p-3 text-center text-gray-500">Loading...</td>
                            </tr>
                        ) : tableData?.length > 0 ? (
                            tableData.map((row, index) => (
                                <tr key={index} className="border border-gray-200">
                                    <td className="p-3 text-start font-semibold text-[#111827]">{row?.emp_name}</td>
                                    <td className="p-3 text-start text-[#111827] font-semibold">{formatToShortDate(row?.created_at)}</td>
                                    <td className="p-3 text-start">{row?.company_name}</td>
                                    <td className="p-3 text-start">--</td>
                                    <td className="p-3 text-start">
                                        <div className='flex justify-between'>
                                            <div>
                                                <div className="inline-block rounded-full bg-[#DCFCE7] text-[#15803D] text-sm px-2 py-1">
                                                    {row.status}
                                                </div>
                                                <div className='text-sm text-[#6B7280]'>Last edited: {formatDateTime(row?.updated_at)}</div>
                                            </div>
                                            <div className='text-[#8B1818] font-semibold cursor-pointer'>View</div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="p-3 text-center text-gray-500">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SuperAdminTable;